import { render, staticRenderFns } from "./BannersTab.vue?vue&type=template&id=283a33d0&scoped=true"
import script from "./BannersTab.vue?vue&type=script&lang=js"
export * from "./BannersTab.vue?vue&type=script&lang=js"
import style0 from "./BannersTab.vue?vue&type=style&index=0&id=283a33d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283a33d0",
  null
  
)

export default component.exports